import { pb } from '../../../shared/api/pocketbase';
import type { ThemeData, ThemeRecord } from './types';

const FIELDS = 'id,data,actual,isCurrent,created';

export const fetchThemes = () =>
  pb.collection('themes').getFullList<ThemeRecord>({ sort: '-created', fields: FIELDS });

export const fetchCurrentTheme = () =>
  pb.collection('themes')
    .getFirstListItem<ThemeRecord>('isCurrent = true', { fields: FIELDS })
    .catch(() => null);

export const createTheme = (data: ThemeData) =>
  pb.collection('themes').create<ThemeRecord>({ data, actual: true, isCurrent: false });

export const updateTheme = (id: string, data: ThemeData) =>
  pb.collection('themes').update<ThemeRecord>(id, { data });

export const deleteTheme = (id: string) =>
  pb.collection('themes').delete(id);

export const activateTheme = async (id: string): Promise<void> => {
  const others = await pb.collection('themes').getFullList<ThemeRecord>({
    filter: `isCurrent = true && id != "${id}"`,
    fields: 'id',
  });
  await pb.collection('themes').update(id, { isCurrent: true });
  await Promise.all(others.map(t => pb.collection('themes').update(t.id, { isCurrent: false })));
};

export const deactivateTheme = (id: string) =>
  pb.collection('themes').update(id, { isCurrent: false });
